import { useState } from 'react';
import { httpClient } from '../api/http';
import { Alert } from '@piggytechng/component-library';

const useTransaction = () => {
  const [isLoading, setIsLoading] = useState(false);

  const deleteTransaction = async (payload: {
    identifier: string;
    password: string;
    wallet: string;
    reference: string;
    reason: string;
  }) => {
    try {
      setIsLoading(true);
      const response: any = await httpClient.post(`admin/user/wallet/delete-transaction`, payload);
      if (response.data.status) {
        Alert.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTransactionMemo = async (wallet: string, reference: string, memo: string): Promise<void> => {
    try {
      setIsLoading(true);
      const response: any = await httpClient.post(`admin/${wallet}/transaction/update-memo/${reference}`, { memo });
      if (response.data.status) {
        Alert.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    deleteTransaction,
    updateTransactionMemo,
  };
};

export default useTransaction;
